// extracted by mini-css-extract-plugin
export var buttonContent = "_2x-0";
export var centered = "_2x-1";
export var centeredFlex = "_2x-2";
export var errorText = "_2x-3";
export var icon = "_2x-4";
export var iconButtonContent = "_2x-5";
export var monospace = "_2x-6";
export var padded = "_2x-7";